import BaseClient from '@/service/client/BaseClient';
import { ResponseData } from '@/service/client/BaseClient.type';
import {
  CreatePrintTaskDto,
  PrintDataVo,
  PrintTaskEntity,
  SearchPrintTaskListReq,
} from '@/service/client/Print.type';
import { ListResult } from '../model/types';
import { IfJavaMapping } from '@/common/constants';

class _PrintClient extends BaseClient {
  public async printData(
    order_id: string,
    tid: string
  ): Promise<ResponseData<PrintDataVo>> {
    return this[this.ifJava(IfJavaMapping.PrintData) ? 'getj' : 'get'](
      '/print/data',
      { id: order_id, tenant_id: tid }
    );
  }

  public async createPrintTask(
    params: CreatePrintTaskDto
  ): Promise<ResponseData<boolean>> {
    return this[this.ifJava(IfJavaMapping.PrintTask) ? 'postj' : 'post'](
      '/print/task',
      params
    );
  }

  public async getTaskList(
    params: SearchPrintTaskListReq
  ): Promise<ResponseData<ListResult<PrintTaskEntity>>> {
    return this.getj('/print/task-list', params);
  }

  public async terminateTask(id: number): Promise<ResponseData<boolean>> {
    return this[
      this.ifJava(IfJavaMapping.PrintTerminateTask) ? 'postj' : 'post'
    ]('/print/terminate-task', { id });
  }

  public async getTaskList_Test(): Promise<
    ResponseData<ListResult<PrintTaskEntity>>
  > {
    return Promise.resolve({
      success: true,
      code: 200,
      message: '',
      data: {
        total: 0,
        list: [],
      },
    });
  }

  public async taskDetail(id: number): Promise<ResponseData<PrintTaskEntity>> {
    return this[this.ifJava(IfJavaMapping.PrintTaskDetail) ? 'getj' : 'get'](
      '/print/task-detail',
      { id }
    );
  }

  public async previewPdfImg(data, name = '我的天'): Promise<ArrayBuffer> {
    return this[
      this.ifJava(IfJavaMapping.PrintPreviewPdfImg) ? 'postj' : 'post'
    ]('/print/preview-pdf-img?name=' + name, data, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json', // 根据服务端要求设置请求头
      },
    });
  }

  public async getTaskDetailWithoutAuth(
    tid: number
  ): Promise<ResponseData<PrintTaskEntity>> {
    return this[this.ifJava(IfJavaMapping.PrintTaskDataFree) ? 'getj' : 'get'](
      '/print/task-data-free',
      {
        tid,
        v: 'aiejf93840fj_mghuqjdos38_fjij292ijdf',
      }
    );
  }
}

export const PrintClient = new _PrintClient();
